export enum TableValueType {
  CHECK = 'Check',
  ACTION = 'Action',
  LIST = 'List',
  LITERAL_LIST = 'Literal_List',
  FUNC = 'Function',
  LITERAL = 'Literal'
}

export interface TableValueAction {
  value: string;
  text: string;
  icon: string;
  actions?: any[];
}

export type TableValueList = Array<any>;

export type TableValueLiteral = boolean | number | string;

export type TableValueSource = any;

export type TableValue =
  | TableValueAction
  | TableValueList
  | TableValueLiteral
  | TableValueSource;

export interface TableRow {
  [name: string]: TableValue;
}

export interface TableColumn {
  type: TableValueType;
  name: string;
  label?: string;
  sort?: boolean;
  filter?: boolean;
  sticky?: boolean;

  literalFormat?: (v: any, item?: any) => string;
  actionFormat?: (item: any, sources?: any) => TableValueAction;
  useObj?: boolean;
  actions?: TableColumn[];
}

export interface TableParams {
  columns: TableColumn[];
  values?: TableRow[];
  filter?: boolean;
  pagination?: boolean;
  ajaxPagination?: TablePaginationParams;
  sortTypes?: SortType[];
}

export interface TablePaginationParams {
  length: number;
  reset?: boolean;
}

export interface SortType {
  key: string;
  type: string;
}

export interface TableActionEvent {
  value: string;
  obj: any;
}

export interface TableItemsParams<T> {
  columns: TableColumn[];
  items: T[];
  sources?: any;
  filter?: boolean;
  pagination?: boolean;
  ctor?: new () => T;

}
